import React from "react";
import { message } from "antd";
import icon_close from "../../../img_4/shareClose.png";
import icon_face from "../../../img_4/facebook.png";
import icon_share from "../../../img_4/share2.png";
import icon_twitter from "../../../img_4/twitter.png";
import "./Share.css";

export default function Share({ flag, setshare }) {
  // facebook
  const shareFacebook = () => {
    window.open(
      "http://www.facebook.com/sharer.php?u=" +
        encodeURIComponent(window.location.origin + "/")
    );
  };

  // twitter
  const shareTwitter = () => {
    window.open(
      "https://twitter.com/share?text=" +
        encodeURIComponent(document.title) +
        "&url=" +
        encodeURIComponent(window.location.origin + "/")
    );
  };

  const [messageApi, contextHolder] = message.useMessage();
  const key = "updatable";
  const openMessage = () => {
    messageApi.open({
      key,
      type: "loading",
      content: "Loading...",
    });
    setTimeout(() => {
      messageApi.open({
        key,
        type: "success",
        content: "You have copied the share link to the clipboard!",
        duration: 2,
      });
    }, 1000);
  };

  const copy = () => {
    // 创建模拟 输入框
    var cInput = document.createElement("input");
    // 当前网址
    cInput.value = window.location.href;
    document.body.appendChild(cInput);
    cInput.select(); // 选取文本框内容

    // 执行浏览器复制命令
    // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
    // Input要在正常的编辑状态下原生复制方法才会生效
    document.execCommand("copy");

    // 复制成功后再将构造的标签 移除
    document.body.removeChild(cInput);
    openMessage();
  };

  return (
    <div className={flag ? "share" : "share share_none"}>
      <div className="close">
        <img src={icon_close} alt="" onClick={setshare} />
      </div>

      <div className="share_icon">
        <img src={icon_face} alt="" onClick={shareFacebook} />
      </div>

      <div className="share_icon">
        <img src={icon_twitter} alt="" onClick={shareTwitter} />
      </div>

      <div className="share_icon">
        <img src={icon_share} alt="" onClick={copy} />
      </div>

      {contextHolder}
    </div>
  );
}
